import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeATCCodeType } from "../Entity/TreeNodeATCCodeType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeATCCodeList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'ATC Codes ({param})');
      this.parent = parent;
      this.labelNodeName = 'ATC Codes';
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated = new TreeNodeATCCodeType(this.ioc!, this);
      nodeCreated.data.model.type_Term = params.nodeType;
      nodeCreated.refreshLabel();
      this.children?.push(nodeCreated);
      this.refreshLabel();
      return [nodeCreated];
    }
  
    override getMessage(): any {
      let atcs: any[] = [];
      this.children?.forEach((node) => {
        let atc = node as TreeNodeATCCodeType;
        let art57Message = atc.getMessage();
        if (art57Message != null) {
          atcs.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return { atcs: { atc: atcs } };
      } else {
        return;
      }
    }
    
    override isStandardTerminology():boolean{
      return true;
    }
  
    override getHeaders(): string[] {
      return ['Operation Type', 'Type', 'ATC Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeATCCodeList = new TreeNodeATCCodeList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }